<template>
  <div style="width: 100%; height: 100%;">
    <div style="width: 100%; height: 50px; line-height: 50px; font-size: 20px; font-weight: bold; text-align: center; background-color: #E8E8E8;">
      BILL OF LADING (HOUSE)
    </div>
    <div style="width: 100%; height: calc(100% - 100px); overflow-y: auto;">
      <div class="container text-left">
        <div class="row">
          <div class="col-6">
            Shipper
            <input class="form-control" v-model="item.shipperTitle" @change="saveItem"/>
            <textarea class="form-control" v-model="item.shipperAddress1" rows="4" placeholder="주소"  @change="saveItem"></textarea>
            <input class="form-control" v-model="item.shipperTel" @change="saveItem" placeholder="Tel" />
            <input class="form-control" v-model="item.shipperEmail" @change="saveItem" placeholder="Email"/>
          </div>
          <div class="col-6">
            B/L No
            <input class="form-control" v-model="item.blNumber" @change="saveItem"/>
            Export References MBL No
            <input class="form-control" v-model="item.mblNo" @change="saveItem"/>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            Consignee
            <input class="form-control" v-model="item.consigneeTitle" @change="saveItem"/>
            <textarea class="form-control" v-model="item.consigneeAddress1" @change="saveItem" rows="4" placeholder="Address"></textarea>
            <input class="form-control" v-model="item.consigneeTel" @change="saveItem" placeholder="Tel"/>
            <input class="form-control" v-model="item.consigneeEmail" @change="saveItem" placeholder="Email"/>
          </div>
          <div class="col-6">
            Point and Country of Origin
            <input class="form-control" v-model="item.pointCountryOfOrigin" @change="saveItem" placeholder="UNITED KINGDOM"/>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            Notify Party

            <select class="form-control" v-model="item.notifyId" @change="onNotifierChanged">
              <option value="0">청구처 선택</option>
              <option v-for="c in customers" :value="c.id">{{c.title}}</option>
            </select>
            <input class="form-control" v-model="item.notifyParty" @change="saveItem"/>
            <textarea class="form-control" v-model="item.notifyPartyAddress" @change="saveItem" rows="4" placeholder="Address"></textarea>
            <input class="form-control" v-model="item.notifyPartyTel" @change="saveItem" placeholder="Tel"/>
            <input class="form-control" v-model="item.notifyPartyEmail" @change="saveItem" placeholder="Email"/>

            <br/><br/>
            Vessel Voy
            <input class="form-control" v-model="item.vessel" @change="saveItem"/>
            Port of Loading
            <input class="form-control" v-model="item.pol" @change="saveItem"/>

            Port of Discharging
            <input class="form-control" v-model="item.pod" @change="saveItem"/>

            Place of Delivery
            <input class="form-control" v-model="item.placeOfDelivery" @change="saveItem"/>
          </div>
          <div class="col-6">
            To Obtain Deliver Order
            <select class="form-control" v-model="item.obtainerId" @change="onObtainerChanged">
              <option value="0">청구처에서 선택</option>
              <option v-for="c in customers" :value="c.id">{{c.title}}</option>
            </select>
            <textarea class="form-control" v-model="item.obtainer" @change="saveItem" rows="4"/>
            <br/>
            <br/>
            Final Destination
            <input class="form-control" v-model="item.finalDestination" @change="saveItem"/>
          </div>
        </div>
        <div class="row" style="margin-top: 20px;">
          <div class="col-12">
            PARTICULARS FURNISHED BY SHIPPER
          </div>
          <div class="col-12">
            <table>
              <tr>
                <th>Marks & Numbers</th>
                <th>NOP</th>
                <th>Description</th>
                <th>GW</th>
                <th>Measurement</th>
              </tr>

              <tr>
                <td>
                  Container Number
                  <input class="form-control" v-model="item.containerNumber" @change="saveItem"/>
                  Seal No
                  <input class="form-control" v-model="item.sealNumber" @change="saveItem"/>
                </td>
                <td>
                  <input type="number" class="number-input" v-model="item.nop" @change="saveItem"/> PKGS
                </td>
                <td>
                  SHIPPER'S LOAD AND COUNT SAID TO CONTAIN
                  <input class="form-control" v-model="item.containerSize" @change="saveItem"/>
                </td>
                <td>
                  <input typ="number" class="number-input" v-model="item.kg" @change="saveItem"/>KG
                </td>
                <td>
                  <input type="number" class="number-input" v-model="item.cbmFloat" @change="saveItem"/>CBM
                </td>
              </tr>
              <tr>
                <td>

                </td>
                <td colspan="3" style="position: relative;">
                  {{item.nop}} <input v-model="item.goodsDescription" style="width: calc(100% - 100px);" @change="saveItem"/>


                  <br/>Additional
                  <textarea class="form-control" v-model="item.blAdditionalPackages" rows="3" @change="saveItem">

                </textarea>
                </td>
                <td>
                  Terms:
                  <input v-model="item.terms" class="form-control" @change="saveItem"/>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="row" style="margin-top: 20px;">
          <div class="col-4">
            Signed By
            <input class="form-control" v-model="item.signedBy" @change="saveItem"/>
          </div>
          <div class="col-4">
            Signed Date
            <input class="form-control" type="date" v-model="item.signedDate" @change="saveItem"/>
          </div>
          <div class="col-4"></div>
        </div>
        <div class="row">
          <div class="col-4">
            Place and Date of issue
            <input class="form-control" type="date" v-model="item.dateOfIssue" @change="saveItem"/>
          </div>
          <div class="col-4">
            On Board Date
            <input class="form-control" type="date" v-model="item.onBoardDate" @change="saveItem"/>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%; height: 50px; line-height: 50px; background-color: #E8E8E8; display: flex;">
      <div style="width: 50%; height: 50px; line-height: 50px;padding-right: 20px; padding-left: 20px; text-align: left;">
        <button class="btn btn-dark" v-on:click="closeItem">Close</button>
      </div>
      <div style="width: 50%; height: 50px; line-height: 50px;padding-right: 20px; padding-left: 20px; text-align: right;">
        <button class="btn btn-danger" v-on:click="getPDF">Generate PDF</button>
        <button class="btn btn-primary" v-if="item.url !== null && item.url.length > 0" v-on:click="openPDF">View PDF</button>

        <button class="btn btn-success" v-on:click="saveItem">SAVE</button>
      </div>

    </div>
    <template v-if="pdfItem !== false">
      <transition name="slideup">
        <pdf-viewer
          :item="pdfItem"
          :on-close="closePdfViewer">

        </pdf-viewer>
      </transition>
    </template>
  </div>
</template>

<script>
  import {getShippingMode} from "../api/request";
  import DatePicker from "vue2-datepicker";
  import {getInvoicePDF, updateInvoice} from "../api/invoices";
  import {generateOrderNumber, millisToDate, showDialog} from "../api/utils";
  import {getLadingPDF, updateHouse} from "../api/houses";
  import PdfViewer from "./PdfViewer";

  export default {
    name: "HouseView",
    data() {
      return {
        type:'',
        shippingModes:getShippingMode(),
        pdfItem:false,
      }
    },
    props: {
      request: {
        type:Object,
        default: function() {return null;}
      },
      item: {
        type:Object,
        default: function(){return null;}
      },
      onUpdated: {
        type:Function,
        default:null,
      },
      onClose: {
        type: Function,
        default:null,
      },
      onDeleted: {
        type: Function,
        default:null,
      },
      customers: {
        type: Array,
        default:() => [],
      }
    },
    components: {
      DatePicker,
      PdfViewer
    },
    created() {
    },
    mounted() {
      this.onLoaded();
    },
    methods: {
      dummy: function () {

      },
      onLoaded: function() {
        let toUpdate = false;
        if(this.item.terms === null || this.item.terms.length === 0) {
          this.item.terms = "CFS/CFS";
          toUpdate = true;
        }
        if(this.item.goodsDescription === null || this.item.goodsDescription.length === 0) {
          this.item.goodsDescription = "C/T BOXES OF USED HOUSEHOLD GOODS & PERSONAL EFFECTS"
          toUpdate = true;
        }

        if(toUpdate === true) {
          this.saveItem();
        }
      },
      openPDF: function() {
        console.log("open pdf");
        console.log(this.request);

        let date = millisToDate(new Date(), '-');
        let emailForm = {
          to: this.item.invoiceToEmail,
          subject:'HBL ' + this.item.blNumber + ' ' + this.item.shipperTitle + ' ' + date,
          body: '안녕하세요 UKO Shipping입니다.\n',
          documents:[{
            title:this.item.blNumber + '-' + this.item.shipperTitle + '-' + generateOrderNumber(),
            url:this.item.url,
          }]
        }
        this.$data.pdfItem = {
          url: this.item.url,
          title: "Bill of Lading " + this.item.blNumber + ' ' + this.item.shipperTitle,
          emailForm: emailForm,
        }
      },
      closePdfViewer: function() {
        this.$data.pdfItem = false;
      },
      getPDF() {
        let self = this;
        // const FileDownload = require('js-file-download');
        // let fileName = "HBL-"+ this.item.blNumber + "-" + this.item.shipperTitle + new Date().getTime() +'.pdf';
        getLadingPDF(this.item.id)
          .then(function(data) {
            if(data.success === true) {
              self.item.url = data.item.url;
              self.openPDF();
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response !== undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, "ERROR");
          })
      },
      closeItem: function() {
        if(this.onClose !== null) {
          this.onClose();
        }
      },

      onObtainerChanged: function() {
        for(let i = 0 ; i < this.customers.length ; i++) {
          if(this.customers[i].id === this.item.obtainerId) {
            this.item.obtainer = this.customers[i].title + "\n"
            + this.customers[i].address + "\n" + this.customers[i].contact + "\n" + this.customers[i].email;
            break;
          }
        }
        this.saveItem();
      },
      onNotifierChanged: function() {
        this.item.notifyParty = '';
        this.item.notifyPartyAddress = '';
        this.item.notifyPartyTel = '';
        this.item.notifyPartyEmail = '';

        for(let i = 0 ; i < this.customers.length ; i++) {
          if(this.customers[i].id === this.item.notifyId) {
            this.item.notifyParty = this.customers[i].title;
            this.item.notifyPartyAddress = this.customers[i].address;
            this.item.notifyPartyTel = this.customers[i].contact;
            this.item.notifyPartyEmail = this.customers[i].email;
          }
        }
        this.saveItem();
      },
      saveItem: function() {
        let self = this;
        this.item.cbm = Math.round(parseFloat(this.item.cbmFloat)*100);
        updateHouse(this.item)
          .then(function(data) {
            if(data.success === true) {
              if(self.onUpdated !== null) {
                self.onUpdated(data.item);
              }
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response !== undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog(msg, "ERROR");
          })
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HouseView.vue